// extracted by mini-css-extract-plugin
export default {"tooltip":"_9PaAokt9","fullbleed":"_1b79lbFP","inverted":"zQ0uIdCr"};